import {
  TranslationContext,
  TranslationKey,
  TranslationModel,
} from "models/translation";
import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import { useStore } from "stores/store";
import { registerLocale, setDefaultLocale } from "react-datepicker";

// add locales to datepicker
import { fi } from "date-fns/locale/fi";
import { sv } from "date-fns/locale/sv";
import { Helmet } from "react-helmet";
import { getTranslations } from "lib/translation";
import { useSearchParams } from "react-router";
import { Locale } from "models/locale";
import { changeLocale } from "stores/actions/locale";
registerLocale("fi", fi);
registerLocale("sv", sv);

interface TranslationProviderProps {
  children: ReactNode;
}

const TranslationProvider: FunctionComponent<TranslationProviderProps> = ({
  children,
}) => {
  const [searchParams, setSearchParam] = useSearchParams();
  let locale = useStore((state) => state.locale);
  const [translations, toggleTranslations] = useState<TranslationModel>(
    getTranslations(locale),
  );

  // check if there is locale in the url
  const localeParam = (searchParams.get("locale") as Locale) || undefined;
  useEffect(() => {
    if (localeParam) {
      // update locale
      changeLocale(localeParam);

      // delete locale part
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("locale"); // Remove the "query" parameter
      setSearchParam(newParams);
    }
  }, [localeParam]);

  useEffect(() => {
    // update translations if the locale changes
    toggleTranslations(getTranslations(locale));

    // translate datepicker as well
    setDefaultLocale(locale);
  }, [locale]);

  const translate = (key: TranslationKey) => translations[key];

  // the actual content in the end
  const HelmetComponent = Helmet as any;
  return (
    <TranslationContext.Provider value={{ translate, translations }}>
      <HelmetComponent>
        <html lang={locale} />
      </HelmetComponent>
      {children}
    </TranslationContext.Provider>
  );
};

export default TranslationProvider;
